/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsReferences
 */
export interface MelcoModelsReferences {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsReferences
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsReferences
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsReferences
     */
    parent_id: string;
}

export function MelcoModelsReferencesFromJSON(json: any): MelcoModelsReferences {
    return MelcoModelsReferencesFromJSONTyped(json, false);
}

export function MelcoModelsReferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsReferences {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'parent_id': json['parent_id'],
    };
}

export function MelcoModelsReferencesToJSON(value?: MelcoModelsReferences | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'parent_id': value.parent_id,
    };
}


